<script>
import PixelBase from "@/components/tools/PixelBase.vue";
export default {
  extends: PixelBase,
  data() {
    return {
      title: "Kwai Ads",
      pixelType: "kwai"
    };
  }
};
</script>
